export default "__VITE_ASSET__Ch14hw0t__"